import { defineStore } from "pinia";
import { Http_getPosList } from "@/http/apiFunction";
import { PosTerminalItem } from "@/http/response.type";

export interface PosState {
  posList: PosTerminalItem[];
  loading: boolean;
  loaded: boolean; // 标记是否已加载过
}

export const useFyPosStore = defineStore({
  id: "fyPos",
  state: (): PosState => ({
    posList: [],
    loading: false,
    loaded: false,
  }),
  getters: {
    // 可用的POS列表
    availablePosList: (state) => {
      return state.posList;
    },
  },
  actions: {
    /**
     * 获取POS列表
     * @param force 是否强制刷新，默认false
     */
    async fetchPosList(force = false) {
      // 如果已经加载过且不是强制刷新，直接返回
      if (this.loaded && !force) {
        return;
      }

      // 防止重复请求
      if (this.loading) {
        return;
      }

      this.loading = true;
      try {
        const res = await Http_getPosList();
        if (res.code === 0) {
          this.posList = res.data;
          this.loaded = true;
        } else {
          console.error("获取POS列表失败:", res.msg);
        }
      } catch (error) {
        console.error("请求POS列表失败:", error);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 重置状态
     */
    reset() {
      this.posList = [];
      this.loading = false;
      this.loaded = false;
    },
  },
});
